<template>
  <el-form
    ref="form"
    label-position="right"
    :model="form"
    :rules="rules"
    label-width="120px"
  >
    <el-form-item size="mini" label="存储类型">
      <el-radio-group v-model="form.type">
        <el-radio :label="1">七牛</el-radio>
        <el-radio :label="2">阿里云</el-radio>
        <el-radio :label="3">腾讯云</el-radio>
      </el-radio-group>
    </el-form-item>
    <template v-if="form.type === 1">
      <el-form-item label="域名">
        <el-input v-model="form.qiniuDomain" placeholder="七牛绑定的域名"></el-input>
      </el-form-item>
      <el-form-item label="路径前缀">
        <el-input v-model="form.qiniuPrefix" placeholder="不设置默认为空"></el-input>
      </el-form-item>
      <el-form-item label="AccessKey">
        <el-input v-model="form.qiniuAccessKey" placeholder="七牛AccessKey"></el-input>
      </el-form-item>
      <el-form-item label="SecretKey">
        <el-input v-model="form.qiniuSecretKey" placeholder="七牛SecretKey"></el-input>
      </el-form-item>
      <el-form-item label="空间名">
        <el-input v-model="form.qiniuBucketName" placeholder="七牛存储空间名"></el-input>
      </el-form-item>
    </template>
    <template v-else-if="form.type === 2">
      <el-form-item label="域名">
        <el-input v-model="form.aliyunDomain" placeholder="阿里云绑定的域名"></el-input>
      </el-form-item>
      <el-form-item label="路径前缀">
        <el-input v-model="form.aliyunPrefix" placeholder="不设置默认为空"></el-input>
      </el-form-item>
      <el-form-item label="EndPoint">
        <el-input v-model="form.aliyunEndPoint" placeholder="阿里云EndPoint"></el-input>
      </el-form-item>
      <el-form-item label="AccessKeyId">
        <el-input v-model="form.aliyunAccessKeyId" placeholder="阿里云AccessKeyId"></el-input>
      </el-form-item>
      <el-form-item label="AccessKeySecret">
        <el-input v-model="form.aliyunAccessKeySecret" placeholder="阿里云AccessKeySecret"></el-input>
      </el-form-item>
      <el-form-item label="BucketName">
        <el-input v-model="form.aliyunBucketName" placeholder="阿里云BucketName"></el-input>
      </el-form-item>
    </template>
    <template v-else-if="form.type === 3">
      <el-form-item label="域名">
        <el-input v-model="form.qcloudDomain" placeholder="腾讯云绑定的域名"></el-input>
      </el-form-item>
      <el-form-item label="路径前缀">
        <el-input v-model="form.qcloudPrefix" placeholder="不设置默认为空"></el-input>
      </el-form-item>
      <el-form-item label="AppId">
        <el-input v-model="form.qcloudAppId" placeholder="腾讯云AppId"></el-input>
      </el-form-item>
      <el-form-item label="SecretId">
        <el-input v-model="form.qcloudSecretId" placeholder="腾讯云SecretId"></el-input>
      </el-form-item>
      <el-form-item label="SecretKey">
        <el-input v-model="form.qcloudSecretKey" placeholder="腾讯云SecretKey"></el-input>
      </el-form-item>
      <el-form-item label="BucketName">
        <el-input v-model="form.qcloudBucketName" placeholder="腾讯云BucketName"></el-input>
      </el-form-item>
      <el-form-item label="Bucket所属地区">
        <el-input v-model="form.qcloudRegion" placeholder="如：sh（可选值 ，华南：gz 华北：tj 华东：sh）"></el-input>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
let origin = {
  type: 1,
  qiniuDomain: '',
  qiniuPrefix: '',
  qiniuAccessKey: '',
  qiniuSecretKey: '',
  qiniuBucketName: '',
  //2，
  aliyunDomain: '',
  aliyunPrefix: '',
  aliyunEndPoint: '',
  aliyunAccessKeyId: '',
  aliyunAccessKeySecret: '',
  aliyunBucketName: '',
  // type3
  qcloudDomain: '',
  qcloudPrefix: '',
  qcloudAppId: '',
  qcloudSecretId: '',
  qcloudSecretKey: '',
  qcloudBucketName: '',
  qcloudRegion: '',
}
export default {
  name: "configForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
        };
      }
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
      },
    }
  },
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },

    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
